export const LIST = "bpOrder/LIST";
export const PROPOSAL = "bpOrder/PROPOSAL";
export const PROPOSAL_ALL = "bpOrder/PROPOSAL_ALL";
export const FILTER = "bpOrder/FILTER";
export const SIZE = "bpOrder/SIZE";
export const PAGE = "bpOrder/PAGE";

export const setList = (data) => ({
    type: LIST,
    payload: data
});

export const setProposal = (data) => ({
    type: PROPOSAL,
    payload: data
});

export const allProposal = (data) => ({
    type: PROPOSAL_ALL,
    payload: data
});

export const filter = (data) => ({
    type: FILTER,
    payload: data
});

export const changeRowSize = (count) => ({
    type: SIZE,
    payload: count
});

export const setPage = (page, path) => ({
    type: PAGE,
    page: page,
    path: path
});